import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnackbarTemplateMaterialModules } from './snackbar-template.module.material';
import { ErrorSnackbarComponent } from './components/error-snackbar/error-snackbar.component';
import { LanguageModule } from '../language/language.module';
import { UniversalSnackbarComponent } from './components/universal-snackbar/universal-snackbar.component';
import { ClipboardModule } from '@angular/cdk/clipboard';

@NgModule({
  declarations: [ErrorSnackbarComponent, UniversalSnackbarComponent],
  imports: [CommonModule, SnackbarTemplateMaterialModules, LanguageModule, ClipboardModule],
  exports: [ErrorSnackbarComponent, UniversalSnackbarComponent],
})
export class SnackbarTemplateModule {}
